import { Button, CircularProgress, Menu, MenuItem, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { ExpandLess, ExpandMore, AccessTime } from '@mui/icons-material'
import moment from 'moment'
import { FragmentType, graphql, useFragment } from '@/generated/gql'

const canteenTimeslotSelectionMenuDataFragment = graphql(`
  fragment CanteenTimeslotSelection_MenuDataFragment on CCMealService {
    timeslots {
      id
      startTime
      endTime
    }
  }
`)

type Props = {
  timeslots?: FragmentType<typeof canteenTimeslotSelectionMenuDataFragment> | null
  selectedTimeslot: string
  onChangeTimeslot: (timeslot: string) => void
}

const TimeslotSelectionGraphql: React.FC<Props> = ({
  timeslots: timeslotsProp,
  selectedTimeslot,
  onChangeTimeslot,
}) => {
  const timeslotData = useFragment(canteenTimeslotSelectionMenuDataFragment, timeslotsProp)
  const timeslots = timeslotData?.timeslots || []
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleTimeslotSelection = (value: string) => {
    onChangeTimeslot(value)
    handleClose()
  }

  const open = Boolean(anchorEl)

  const selectedTimeslotOption = timeslots.find((timeslot) =>
    moment(timeslot.startTime).isSame(moment(selectedTimeslot)),
  )

  return (
    <>
      <Button
        disabled={timeslots.length <= 1}
        onClick={handleClick}
        aria-haspopup="true"
        id="basic-button"
        variant="outlined"
        size="medium"
        fullWidth
        sx={{
          borderColor: 'divider',
          minHeight: '40px',
          boxShadow: 'none',
          overflow: 'hidden',
        }}
        startIcon={<AccessTime color="primary" />}
        endIcon={
          timeslots.length <= 1 ? null : (
            <>{open ? <ExpandLess color="action" /> : <ExpandMore color="action" />}</>
          )
        }
      >
        <Typography noWrap>
          {selectedTimeslotOption ? (
            <>
              {moment(selectedTimeslotOption?.startTime).format('HH:mm')} -{' '}
              {moment(selectedTimeslotOption?.endTime).format('HH:mm')}
            </>
          ) : (
            <CircularProgress size={15} />
          )}
        </Typography>
      </Button>
      <Menu
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          maxHeight: '400px',
        }}
        anchorEl={anchorEl}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        id="basic-menu"
      >
        <Stack width={170}>
          {timeslots.map((timeslot) => (
            <MenuItem
              onClick={() => handleTimeslotSelection(timeslot.startTime)}
              key={`${timeslot.startTime}-${timeslot.endTime}`}
            >
              <Typography paddingX={2}>
                {moment(timeslot.startTime).format('HH:mm')} -{' '}
                {moment(timeslot.endTime).format('HH:mm')}
              </Typography>
            </MenuItem>
          ))}
        </Stack>
      </Menu>
    </>
  )
}

export default TimeslotSelectionGraphql
